import type { ReactElement } from 'react'

export interface BadgeProps {
  className?: string
  onClick?: () => void
  style?: BadgeStyleType
  size?: BadgeSizeType
  surfaceColor?: BadgeSurfaceColorType
  value?: number
  children?: React.ReactNode
}

export enum BadgeStyle {
  positive = 'positive',
  critical = 'critical',
  neutral = 'neutral',
  contrast = 'contrast',
}

export enum BadgeSize {
  xsmall = 'xs',
  small = 's',
  medium = 'm',
}

export enum BadgeSurfaceColor {
  primary = 'primary',
  secondary = 'secondary',
  positive = 'positive',
  critical = 'critical',
  warning = 'warning',
  marketing = 'marketing',
  loyalty = 'loyalty',
  persistentLight = 'persistentLight',
  persistentDark = 'persistentDark',
}

export type BadgeStyleType = `${BadgeStyle}`
export type BadgeSizeType = `${BadgeSize}`
export type BadgeSurfaceColorType = `${BadgeSurfaceColor}`
export type BadgeComponentType = ReactElement<BadgeProps>
